import React, { useState, useEffect, useCallback } from "react";
import UpcomingEditingBookingTable from "../UpcomingEditingBookingTable/UpcomingEditingBookingTable";
import { getEditingBookingsAPI } from "../../../../utils/APIs/hourlyAndEditingBookingsApis";

const LIMIT = 10;

const UpcomingEditingPage = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getEditingBookingsAPI(page, LIMIT, "upcoming");
      console.log("Editing Bookings API Response:", res.data);
      if (res.data && res.data.success) {
        setData(res.data.data || []);
        setTotal(res.data.meta?.total || 0);
      }
    } catch (error) {
      console.error("Error fetching editing bookings:", error);
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const totalPages = Math.ceil(total / LIMIT);

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 3;
    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, page + 2);

    if (end - start < maxVisible - 1) {
      if (start === 1) {
        end = Math.min(totalPages, start + maxVisible - 1);
      } else if (end === totalPages) {
        start = Math.max(1, end - maxVisible + 1);
      }
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  if (loading && data.length === 0) return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
      Loading...
    </div>
  );

  return (
    <>
      <UpcomingEditingBookingTable
        data={data}
        page={page}
        limit={LIMIT}
        refetchData={fetchData}
      />

      {total > LIMIT && (
        <div className="pagination">
          <button
            className="pagination-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>

          {getPageNumbers().map((p) => (
            <button
              key={p}
              className={`pagination-btn ${p === page ? "active" : ""}`}
              onClick={() => setPage(p)}
            >
              {p}
            </button>
          ))}

          <button
            className="pagination-btn"
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )}
    </>
  );
};

export default UpcomingEditingPage;
